
import React, { createContext, useContext } from 'react';
import { getSessionId, getParam, getBaseUrl } from "../adapters/ApexAdapter";
import { useIsAuthenticated, useMsal } from '@azure/msal-react';

const AuthContext = createContext(null);
const AuthProvider = ({children, authTypes}) => {
    return (
        <AuthContext.Provider value={authTypes}>
            {children}
        </AuthContext.Provider>
    )
};


const useAuthProvider = (): [boolean, string, string] => {
    const { instance } = useMsal();
    const account = instance.getActiveAccount();
    let sessionId = getSessionId();
    const authTypes = useContext(AuthContext);
    let authorized = false;
    let authType = '';
    let token = sessionId;
    if(!Array.isArray(authTypes)){
        return [authorized, authType, token];
    }
    const isAuthenticated = useIsAuthenticated();
    let secureLink  = getParam("secureLink");
    if(secureLink && secureLink.length > 0 && secureLink !== "null"){
        secureLink = sessionId;
        sessionId = '';
    }
    token = localStorage.getItem("identity_token");
    const loginType = localStorage.getItem("login_type");
    if(token === null){
        token = sessionId;
    }
    if(loginType === "link"){
        secureLink = token;
        sessionId = "";
    }
    authTypes.map((type) => {
        if(authorized){
            return null;
        }
        switch(type){
            case 'link':
                if(token !== null && token.length > 0 && loginType === "link"){
                    authorized = true;
                    authType = type;
                }
                break;
            case 'microsoft':
                if(token !== null && token.length > 0 && (loginType === "microsoft")){
                    authorized = true;
                    authType = type;
                }
                break;
            case 'google':
                if(token !== null && token.length > 0 && (loginType === "google")){
                    authorized = true;
                    authType = type;
                }
                break;
            case 'github':
                if(token !== null && token.length > 0 && (loginType === "github")){
                    authorized = true;
                    authType = type;
                }
                break;
            case 'facebook':
                if(token !== null && token.length > 0 && (loginType === "facebook")){
                    authorized = true;
                    authType = type;
                }
                break;
            case 'apple':
                if(token !== null && token.length > 0 && (loginType === "apple")){
                    authorized = true;
                    authType = type;
                }
                break;
            case 'salesforce':
                if(sessionId.length > 0){
                    authorized = true;
                    authType = type;
                }
                break;
            default:
                break;
        }
        return null;
    });

    // console.log("Authorized = "+authorized, authType);
    return [ authorized, authType, token ];
};

export { AuthProvider, AuthContext, useAuthProvider };